export enum TaskModalModes {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
